export const SUPPORTED_NETWORKS = {
	1: "MAINNET",
	56: "BSC",
	137: "POLYGON",
	1285: "moonriver",
	42: "KOVAN",
	97: "BSCTEST",
	80001: "MUMBAI",
	1287: "moonbase-alphanet",
	1337: true ? "MAINNET" : "POLYGON", // ! test network
};
